import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import { FOOTER_HEIGHT, TOUCH_HEIGHT, SIDE_NAV_OPENED_WIDTH, SIDE_NAV_CLOSED_WIDTH } from '../SideNavigation.constants.js';
import { Container } from '../../Menu/Menu.styles.js';

var _templateObject;
var getLeftPosition = function getLeftPosition(_ref) {
  var $isTouch = _ref.$isTouch,
    $isOpen = _ref.$isOpen;
  if ($isTouch) {
    return 0;
  }
  if ($isOpen) {
    return SIDE_NAV_OPENED_WIDTH;
  }
  return SIDE_NAV_CLOSED_WIDTH;
};
var StyledSubMenu = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-top: ", ";\n  left: ", ";\n  border-left: ", ";\n  position: ", ";\n  top: ", ";\n  visibility: ", ";\n\n  /**\n  Calculating the max-height for the scrollable menu and keeping it to the correct height.\n  For touch, the calculation is: 3.5rem (footer) + 3rem (header) + 3rem (selected item) + 0.1875rem (3 border lines)\n  */\n  max-height: calc(\n    100vh - ", " - ", " - ", " - 0.1875rem\n  );\n\n  overflow-y: auto;\n\n  // Removing the border of the menu as it disappears on scroll.\n  // The border is on the styled sub menu, which wraps the menu.\n  & ", " {\n    border: none;\n  }\n"])), function (_ref2) {
  var theme = _ref2.theme,
    $isTouch = _ref2.$isTouch,
    $isSubmenuOpen = _ref2.$isSubmenuOpen;
  return $isTouch && $isSubmenuOpen ? "".concat(theme.sizing.xxtiny, " solid ").concat(theme.colours.canvas.secondary.main) : 'none';
}, getLeftPosition, function (_ref3) {
  var theme = _ref3.theme,
    $isTouch = _ref3.$isTouch;
  return !$isTouch && "".concat(theme.sizing.xxtiny, " solid ").concat(theme.colours.canvas.primary.main);
}, function (_ref4) {
  var $isSelected = _ref4.$isSelected,
    $isTouch = _ref4.$isTouch;
  return $isSelected && $isTouch ? 'relative' : 'fixed';
}, function (_ref5) {
  var $topOffset = _ref5.$topOffset,
    $isSelected = _ref5.$isSelected,
    $isTouch = _ref5.$isTouch;
  return $isSelected && $isTouch ? '' : "".concat($topOffset, "px");
}, function (_ref6) {
  var $isSubmenuOpen = _ref6.$isSubmenuOpen;
  return $isSubmenuOpen ? 'visible' : 'hidden';
}, FOOTER_HEIGHT, TOUCH_HEIGHT, TOUCH_HEIGHT, Container);

export { StyledSubMenu, StyledSubMenu as default };
//# sourceMappingURL=SideNavigationSubMenu.styles.js.map
